export default __webpack_public_path__ + "static/media/495.bd9e83f9.jpg";